import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.Terms;

type Props = {
  isExpanded: boolean;
  onToggle: () => void;
};

/** "Shrnutí a dokumenty" / "Skrýt shrnutí" text button that opens and closes the summary block. */
export const SocialTermsSummaryToggle = ({ isExpanded, onToggle }: Props) => {
  const { t } = useResource();

  return (
    <Button
      variant="text"
      size="small"
      onClick={onToggle}
      endIcon={isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      sx={{ alignSelf: "flex-start", px: 0 }}
    >
      {t(isExpanded ? RESOURCES.HideSummary : RESOURCES.ShowSummary)}
    </Button>
  );
};
